// Phase 9A.5.1 — Public signal control styles.
//
// Filter chips, save / saved buttons, inspect button. Token-only.
// No hex literals, no rgb/rgba, no new tokens. Behavior identical to
// the chrome previously colocated in public-signal-card.styles.ts.

import type { CSSProperties } from "react";

// ─── Filter strip ───────────────────────────────────────────────

export const filterRow: CSSProperties = {
  display: "flex",
  flexWrap: "wrap",
  gap: "var(--sz-space-2)",
  alignItems: "center",
  paddingTop: "var(--sz-space-2)",
  paddingBottom: "var(--sz-space-2)",
  borderTop: "1px solid var(--sz-border-subtle)",
  borderBottom: "1px solid var(--sz-border-subtle)",
};

export const filterLabel: CSSProperties = {
  fontFamily: "var(--sz-font-mono)",
  fontSize: "var(--sz-mono-xs)",
  letterSpacing: "1.5px",
  textTransform: "uppercase",
  color: "var(--sz-text-muted)",
};

export const filterChip: CSSProperties = {
  fontFamily: "var(--sz-font-mono)",
  fontSize: "var(--sz-mono-xs)",
  letterSpacing: "1.5px",
  textTransform: "uppercase",
  padding: "4px 10px",
  borderRadius: "var(--sz-radius-sm)",
  border: "1px solid var(--sz-border-default)",
  background: "transparent",
  color: "var(--sz-text-secondary)",
  cursor: "pointer",
};

export const filterChipActive: CSSProperties = {
  ...{
    fontFamily: "var(--sz-font-mono)",
    fontSize: "var(--sz-mono-xs)",
    letterSpacing: "1.5px",
    textTransform: "uppercase",
    padding: "4px 10px",
    borderRadius: "var(--sz-radius-sm)",
    cursor: "pointer",
  },
  border: "1px solid var(--sz-football)",
  background: "transparent",
  color: "var(--sz-football)",
};

// ─── Inspect / Save / Saved buttons ─────────────────────────────

export const inspectButton: CSSProperties = {
  fontFamily: "var(--sz-font-mono)",
  fontSize: "var(--sz-mono-xs)",
  letterSpacing: "1.5px",
  textTransform: "uppercase",
  padding: "6px 12px",
  borderRadius: "var(--sz-radius-sm)",
  border: "1px solid var(--sz-football)",
  color: "var(--sz-football)",
  background: "transparent",
  cursor: "pointer",
  alignSelf: "flex-start",
};

export const saveButton: CSSProperties = {
  fontFamily: "var(--sz-font-mono)",
  fontSize: "var(--sz-mono-xs)",
  letterSpacing: "1.5px",
  textTransform: "uppercase",
  padding: "6px 12px",
  borderRadius: "var(--sz-radius-sm)",
  border: "1px solid var(--sz-border-default)",
  color: "var(--sz-text-secondary)",
  background: "transparent",
  cursor: "pointer",
  alignSelf: "flex-start",
};

export const savedButton: CSSProperties = {
  fontFamily: "var(--sz-font-mono)",
  fontSize: "var(--sz-mono-xs)",
  letterSpacing: "1.5px",
  textTransform: "uppercase",
  padding: "6px 12px",
  borderRadius: "var(--sz-radius-sm)",
  border: "1px solid var(--sz-football)",
  color: "var(--sz-football)",
  background: "transparent",
  cursor: "pointer",
  alignSelf: "flex-start",
};
